import React from "react";
import iconEllipse from "@/assets/svgs/icon-ellipse.png";
import iconDotted from "@/assets/svgs/icon-dotted.png";
import { checkType } from "@/utils/check-type-etr-status";
import { uniqueId } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

export const EndorsementChainSection = ({ endorsementChainLists }) => {
    return (
        endorsementChainLists?.length ? <div style={{ display: "flex", flexDirection: "column", gap: "64px" }}>
            <div className='endorsement_chain__container__table'>
                {endorsementChainLists?.map((item, index) => {
                    const id = uniqueId()
                    return (
                        <div className="endorsement_chain__container__table__row__remarks" key={id}>
                            <div className="endorsement_chain__container__table__col__remarks">
                                <div className="endorsement_chain__ellipse">
                                    <img
                                        src={iconEllipse}
                                        style={{
                                            width: "8px",
                                            height: "8px",
                                            maxWidth: "none",
                                            maxHeight: "none",
                                        }}
                                        alt="info"
                                    />
                                    {(endorsementChainLists?.length - 1 !== index) && (
                                        <div className="etr__endorsement_chain__container__table__col__line__remarks">
                                            <img src={iconDotted} alt="dotted line" style={{ width: "100%" }} />
                                        </div>
                                    )}
                                    <span className='endorsemtn_chain__content__remarks'>
                                        <span className='endorsement_chain__text__title__remarks'>{checkType(item.type)}</span>
                                    </span>
                                </div>
                                <div className="">
                                    <div className='endorsemtn_chain__content'>
                                        <span className='endorsement_chain__text__sub'>
                                            {moment.utc(item.timestamp).format('DD/MM/YYYY, HH:mm A')}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="endorsement_chain__container__table__col__remarks__address">
                                <div>
                                    <div className='endorsemtn_chain__content'>
                                        <span className='endorsement_chain__text__sub'>Owner</span>
                                    </div>
                                    <div className='endorsemtn_chain__content'>
                                        <span className='endorsement_chain__text__sub__remarks'>{item?.owner}</span>
                                    </div>
                                </div>
                                <div>
                                    <div className='endorsemtn_chain__content'>
                                        <span className='endorsement_chain__text__sub'>Holder</span>
                                    </div>
                                    <div className='endorsemtn_chain__content'>
                                        <span className='endorsement_chain__text__sub__remarks'>{item?.holder}</span>
                                    </div>
                                </div>
                                <div>
                                    <div className='endorsemtn_chain__content'>
                                        <span className='endorsement_chain__text__sub'>Remarks</span>
                                    </div>
                                    <div className='endorsemtn_chain__content'>
                                        <span className='endorsement_chain__text__sub__remarks'>{item?.remark || '-'}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div> : null
    )
}

EndorsementChainSection.propTypes = {
    endorsementChainLists: PropTypes.array,
}